var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftteamsDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "original_copy",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24",
  style: {
    enableBackground: "new 0 0 24 24"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#FFFFFF;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_11_",
  className: "st0",
  d: "M19.5,3.2c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3s2.3-1,2.3-2.3S20.8,3.2,19.5,3.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.2,10.1h-3.9v7.2c0,0.9-0.8,1.6-1.7,1.6H7.1c0.7,2.1,2.7,3.7,5.1,3.9c3.4,0.2,6.2-2.3,6.2-5.5v-6.1 C18.4,10.6,17.9,10.1,17.2,10.1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M21.8,10.1h-3.1c0.2,0.3,0.4,0.7,0.4,1.1v6.1c0,0.7-0.1,1.4-0.3,2c0.2,0.1,0.5,0.1,0.7,0.1 c1.9,0,3.5-1.6,3.5-3.5v-4.6C23,10.6,22.5,10.1,21.8,10.1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.6,7.8H2c-0.5,0-1,0.4-1,0.9v8.7c0,0.5,0.4,0.9,1,0.9h9.6c0.5,0,1-0.4,1-0.9V8.7C12.6,8.2,12.1,7.8,11.6,7.8 z M9.1,11.1H7.4v4.8H6.2v-4.8H4.5v-1h4.6V11.1z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.6,3.7C15,2.7,13.8,2,12.6,2s-2.4,0.7-3,1.7C9,4.8,9,6,9.5,7h2.1c1,0,1.7,0.7,1.7,1.6v0.2 c0.9-0.2,1.8-0.8,2.3-1.6C16.2,6.1,16.2,4.8,15.6,3.7z"
})));
export { SvgMicrosoftteamsDark as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoftteamsDark.240a16f7.svg";